import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

const FeatureItems = [
  {
    title: "Experiential Learning",
    info: "Future of Skills Training with Certification and Supplemented by Industry-recognised Living and Soft Skills delivered through in-person and virtual sessions.",
    image: "feature-image-01.png",
    bgColor: "card-bg-1",
    link: "#",
  },
  {
    title: "On-the-Job Training",
    info: "Professional Apprenticeship through Match and Placement with Industry Partners for a Real Workplace Experience",
    image: "feature-image-02.png",
    bgColor: "card-bg-2",
    link: "#",
  },
  // {
  //   title: "Mentorship",
  //   info: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //   image: "feature-image-03.png",
  //   bgColor: "card-bg-3",
  //   link: "#",
  // },
  {
    title: "Mentorship",
    info: "Paired with dedicated mentors who will provide ongoing guidance and support through your journey",
    image: "feature-image-04.png",
    bgColor: "card-bg-4",
    link: "#",
  },
];

const KYouthFeature = ({ wrapperClass, alignment, style }) => {
  return (
    <div className={`row ${wrapperClass || "g-5 mt--20"}`}>
      {FeatureItems.map((data, i) => (
        <ScrollAnimation
          animateIn="fadeInUp"
          animateOut="fadeInOut"
          className={`col-lg-4 col-md-12 col-12 ${alignment ? alignment : ""} ${
            style ? style : ""
          }`}
          animateOnce={true}
          key={i}
        >
          <div
            className={`service-card service-card-2 ${data.bgColor}`}
            style={{ height: "100%" }}
          >
            <div className="inner">
              <div className="icon">
                <a href={data.link}>
                  <img
                    src={`${process.env.PUBLIC_URL}/k-youth/images/feature/feature-01/${data.image}`}
                    alt="Feature Thumb"
                  />
                </a>
                <div className="shape-list">
                  <img
                    className="shape shape-1"
                    src="/k-youth/images/feature/feature-01/feature-icon-01.png"
                    alt="Shape Particle"
                  />
                  <img
                    className="shape shape-2"
                    src="/k-youth/images/feature/feature-01/feature-icon-02.png"
                    alt="Shape Particle"
                  />
                  <img
                    className="shape shape-3"
                    src="/k-youth/images/feature/feature-01/feature-icon-03.png"
                    alt="Shape Particle"
                  />
                </div>
              </div>
              <div className="content">
                <h6 className="title">
                  <a href={data.link}>{data.title}</a>
                </h6>
                <p className="description">{data.info}</p>
              </div>
            </div>
          </div>
        </ScrollAnimation>
      ))}
    </div>
  );
};

export default KYouthFeature;
